import { render, staticRenderFns } from "./Induk.vue?vue&type=template&id=7682eb02&"
import script from "./Induk.vue?vue&type=script&lang=js&"
export * from "./Induk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports